// @flow
import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import AppStore from 'stores/AppStore';
import type { Permission } from './definePermission';
import PermissionsContext from './PermissionsContext';
import { userHasPermissions } from './utils';

type AuthGateProps = {
  allowed?: Permission[],
  disallowed?: Permission[],
  canInvoke?: any[],
  fallback?: any,
  children: any
};

const compliesWithPermissions = (user, permissions: Permission[]) =>
  permissions.reduce(
    (complies, permission) => complies && permission.authorize(user),
    true
  );

const AuthGate = ({
  allowed = [],
  disallowed = [],
  canInvoke = [],
  fallback = <Redirect to="/" />,
  children
}: AuthGateProps) => {
  const permissions = useContext(PermissionsContext);
  const currentUser = AppStore.getCurrentUser();

  if (allowed.length > 0 && !compliesWithPermissions(currentUser, allowed)) {
    return fallback;
  }

  if (canInvoke.length > 0 && permissions.length > 0) {
    const canInvokeEndpoints =
      canInvoke
        .map(endpoint =>
          userHasPermissions(permissions, endpoint.url, endpoint.method)
        )
        .indexOf(false) === -1;

    if (!canInvokeEndpoints) {
      return fallback;
    }
  }

  return children;
};

export default AuthGate;
